<template>
    <div>
        <nav class="navbar navbar-dark bg-dark justify-content-between flex-nowrap flex-row">
        <div class="container">
            <a class="navbar-brand float-left">
                <img src="https://static.innovorder.fr/dashboard/images/logo-menu-new.png" class="logo">
                Order Display System
            </a>
            <ul class="nav navbar-nav flex-row float-right">
            <li class="nav-item">
                <router-link class="nav-link pr-3" to="/create">Gestion</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link pr-3" to="/config">Configuration</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/list">Affichage en salle</router-link>
            </li>
            </ul>
        </div>
        </nav>
        <div class="container mt-5">
            <div class="row justify-content-center">
                <div class="col-md-5">
                    <h3 class="text-center">Configuration</h3>
                    <form @submit.prevent="onFormSubmit">
                        <div class="form-group">
                            <label>URL du logo de l'afficheur</label>
                            <input type="text" class="form-control" v-model="logoUrl" required>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-warning btn-block">Sauvegarder</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
    import { db } from '../firebaseDb';

    export default {
        data() {
            return {
                logoUrl: '',
                restaurantId: 0
            }
        },
        created() {
            this.restaurantId = this.$cookies.get('ods-restaurant-id');
            db.doc('restaurants/'+this.restaurantId).get().then((snapshotChange) => {
                const restaurantConfig = snapshotChange.data();
                this.logoUrl = restaurantConfig.logoUrl;
            });
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault()
                db.doc('restaurants/'+this.restaurantId).set({logoUrl: this.logoUrl }).then(() => {
                    alert('Configuration mise à jour !')
                }).catch((error) => {
                    alert('Une erreur est survenue ('+JSON.stringify(error)+')');
                });
            }
        }
    }
</script>

<style scoped>
    .logo {
        max-width: 135px;
        max-height: 22px;
    }
    .btn-primary {
        margin-right: 12px;
    }
</style>